import React, { useMemo, createContext, useContext } from 'react'
import { useLocalStorage } from '../Hooks/useLocalStorage'
import { FC } from '../Services/FeathersClient'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Growl } from '../Components'

const AuthContext = createContext(null)

function AuthProvider () {
  const [user, setUser] = useLocalStorage('user', null)
  const navigate = useNavigate()
  const location = useLocation()

  const onLogin = async (loginData) => {
    try {
      const userData = await FC.login({ ...loginData, strategy: 'local' })
      if (!userData) {
        return window.growl.show({
          severity: 'error',
          summary: 'Errore',
          detail: 'Credenziali errate'
        })
      }
      setUser(userData)
      const origin = location?.state?.from?.pathname || '/'
      navigate(origin)
    } catch (error) {
      window.growl.show({
        severity: 'error',
        summary: 'Errore',
        detail: 'Errore durante il login'
      })
    }
  }

  const onLoginJWT = async (jwt) => {
    try {
      const userData = await FC.login({ strategy: 'jwt', accessToken: jwt })
      setUser(userData)
    } catch (error) {
      setUser(null)
      navigate('/login')
    }
  }

  const onLogout = () => {
    FC.logout()
    setUser(null)
    navigate('/login')
    window.reload()
  }

  const value = useMemo(
    () => ({
      user,
      onLogin,
      onLoginJWT,
      onLogout
    }),
    [user]
  )

  return (
    <AuthContext.Provider value={value}>
      <Growl />
      <Outlet />
    </AuthContext.Provider>
  )
}

export default AuthProvider

export const useAuth = () => useContext(AuthContext)
